export type Bonus = {
  label: string;
  title: string;
  utility: string;
  description: string;
  image: string;
};
export type Faq = {
  question: string;
  answer: string;
};
export type Need = {
  label: string;
  color: string;
};
export type Step = {
  title: string;
  description: string;
};
export type Situation = {
  title: string;
  description: string;
};
export type ComparisonRow = {
  loose: string;
  kit: string;
};
export type Moment = {
  need: string;
  title: string;
  description: string;
};
export type CardSlide = {
  reference: string;
  image: string;
};
export const checkoutUrl = 'https://botiquin-espiritual.impultienda.ar/checkout';
export const launchOffer = {
  regularPrice: '$79',
  price: '$13,90',
  paymentNote: 'Pago único. Sin suscripciones.'
};
export const cta = {
  label: 'QUIERO MI BOTIQUÍN ESPIRITUAL',
  short: 'QUIERO MI BOTIQUÍN',
  secondary: 'QUIERO TENERLO SIEMPRE CERCA',
  heroMicro: 'Acceso inmediato · PDF listo para imprimir · 4 bonos incluidos · Garantía de 7 días',
  offerMicro: 'Acceso inmediato · Producto digital · Listo para imprimir · Garantía de 7 días',
  finalMicro: 'Acceso inmediato · $13,90 · Pago único'
};

// Imágenes oficiales del producto.
export const productImages = {
  hero: 'https://cdn.magicpatterns.com/uploads/v5NZ9aPmPNniY7GAJEx7Ar/ChatGPT_Image_25_sept_2026,_09_35_10_a.m..png',
  heroAlt: 'Botiquín Espiritual: cajita imprimible junto a tarjetas bíblicas sobre una mesa',
  howItWorks: 'https://cdn.magicpatterns.com/uploads/v4HpZv8sZw8LLoQpZVK7Li/ChatGPT_Image_25_sept_2026,_09_43_19_a.m..png',
  howItWorksAlt: 'Cajita Botiquín Espiritual junto a tarjetas bíblicas con versículos',
  offer: 'https://cdn.magicpatterns.com/uploads/3oeq8ZFHFDrDB7aXjHkLRf/ChatGPT_Image_25_sept_2026,_10_00_21_a.m..png',
  offerAlt: 'Botiquín Espiritual completo: cajita, tarjetas bíblicas y los 4 bonos'
};
export const hero = {
  eyebrow: 'Una Palabra de Dios para cada necesidad',
  productName: 'Botiquín Espiritual',
  subtitle: '50 tarjetas bíblicas organizadas para esos momentos en los que necesitas paz, fortaleza, confianza o esperanza.'
};
export const cardPreview = {
  title: 'Mira tu Botiquín por dentro',
  subtitle: '50 tarjetas bíblicas listas para imprimir, recortar y tener siempre cerca.',
  closing: 'Organizadas para que, cuando necesites una Palabra de Dios, sepas exactamente dónde buscar.'
};
export const cardSlides: CardSlide[] = [{
  reference: 'Filipenses 4:6',
  image: 'https://cdn.magicpatterns.com/uploads/htEHY4hYd3B66s4uriaYED/01_Filipenses_4-6.png'
}, {
  reference: 'Jeremías 17:7',
  image: 'https://cdn.magicpatterns.com/uploads/tQUnrU9hvi7aF61mbScXsi/02_Jeremias_17-7.png'
}, {
  reference: 'Mateo 11:28',
  image: 'https://cdn.magicpatterns.com/uploads/aN75PmREotCMNEk9CQq6SR/03_Mateo_11-28.png'
}, {
  reference: 'Jeremías 33:3',
  image: 'https://cdn.magicpatterns.com/uploads/k6ivrZJRqSBLmwigzBwoaj/04_Jeremias_33-3.png'
}, {
  reference: '1 Pedro 5:7',
  image: 'https://cdn.magicpatterns.com/uploads/qbJ2XPZnxSAzZ4Gqb66ePh/05_1_Pedro_5-7.png'
}, {
  reference: 'Salmos 46:10',
  image: 'https://cdn.magicpatterns.com/uploads/ugtne2p3gYA3vQiAjMPbGv/06_Salmos_46-10.png'
}];
export const needs: Need[] = [{
  label: 'Paz',
  color: '#7fb3c9'
}, {
  label: 'Fortaleza',
  color: '#c97a3c'
}, {
  label: 'Confianza',
  color: '#5aa36b'
}, {
  label: 'Esperanza',
  color: '#d8b35a'
}, {
  label: 'Ansiedad y preocupación',
  color: '#8f6fc0'
}, {
  label: 'Momentos difíciles',
  color: '#b4544a'
}];
export const pain = {
  headline: 'Sabes que la Biblia tiene una respuesta… pero a veces no sabes dónde buscarla.',
  situations: [{
    title: 'Cuando tu mente está llena de preocupaciones',
    description: 'y no sabes por dónde empezar el día.'
  }, {
    title: 'Cuando necesitas paz',
    description: 'y todo a tu alrededor se siente acelerado.'
  }, {
    title: 'Cuando tienes que tomar una decisión',
    description: 'y quieres escuchar a Dios antes de dar el paso.'
  }, {
    title: 'Cuando necesitas fuerzas para seguir',
    description: 'y el cansancio pesa más de lo habitual.'
  }, {
    title: 'Cuando quieres orar pero no encuentras las palabras',
    description: 'y necesitas que Su Palabra hable primero.'
  }] as Situation[],
  close: 'Para esos momentos creamos Botiquín Espiritual.'
};
export const mechanism = {
  title: 'No busques entre cientos de versículos cuando más necesitas una respuesta.',
  description: 'Botiquín Espiritual organiza la Palabra de Dios según lo que estás atravesando. Identificas tu necesidad, vas directo a la tarjeta indicada y encuentras una Palabra para ese momento.',
  needsLabel: 'Tarjetas organizadas por necesidad',
  closing: 'No son solo 50 versículos. Es una forma sencilla de saber dónde buscar cuando necesitas una Palabra de Dios.'
};
export const comparison: ComparisonRow[] = [{
  loose: 'Capturas y notas que después no encuentras',
  kit: 'Tarjetas organizadas según lo que estás viviendo'
}, {
  loose: 'Buscar al azar justo cuando más lo necesitas',
  kit: 'La tarjeta indicada en segundos, con el Mapa de Emergencia'
}, {
  loose: 'En el teléfono, entre notificaciones y distracciones',
  kit: 'Una cajita en casa, siempre a mano'
}, {
  loose: 'Leer y seguir de largo',
  kit: 'Leer, reflexionar, orar y llevar la Palabra contigo'
}];
export const steps: Step[] = [{
  title: 'Identifica',
  description: '¿Qué necesita hoy tu corazón?'
}, {
  title: 'Encuentra',
  description: 'Busca la tarjeta indicada.'
}, {
  title: 'Lee',
  description: 'Encuentra una Palabra para ese momento.'
}, {
  title: 'Reflexiona y ora',
  description: 'Dedica unos minutos a volver tu mirada a Dios.'
}, {
  title: 'Llévala contigo',
  description: 'Ten esa Palabra cerca durante tu día.'
}];
export const moments: Moment[] = [{
  need: 'Paz',
  title: 'Al empezar el día',
  description: 'Antes de mirar el teléfono, una tarjeta para poner tus pensamientos en Dios.'
}, {
  need: 'Ansiedad y preocupación',
  title: 'Cuando la mente no se detiene',
  description: 'Una Palabra para soltar lo que no puedes controlar y dejarlo en Sus manos.'
}, {
  need: 'Fortaleza',
  title: 'Antes de algo importante',
  description: 'Una entrevista, un trámite, una conversación difícil. Lleva la tarjeta contigo.'
}, {
  need: 'Confianza',
  title: 'Frente a una decisión',
  description: 'Para recordar que no caminas solo mientras esperas una respuesta.'
}, {
  need: 'Momentos difíciles',
  title: 'Cuando alguien que amas lo necesita',
  description: 'Comparte una tarjeta con un familiar o un amigo que está atravesando un momento duro.'
}, {
  need: 'Esperanza',
  title: 'Al terminar el día',
  description: 'Un versículo y una oración breve para descansar agradecido.'
}];
export const bonuses: Bonus[] = [{
  label: 'Bono #1',
  title: 'Mapa de Emergencia Espiritual',
  utility: 'Tu guía rápida para saber qué tarjeta tomar según lo que estás viviendo.',
  description: 'Encuentra en segundos las tarjetas para cuando necesitas paz, fortaleza, confianza, esperanza o acompañamiento en un momento difícil.',
  image: 'https://cdn.magicpatterns.com/uploads/u2E5DP1d5XnvJpQaUTowmA/02_bono_1_mapa_emergencia.png'
}, {
  label: 'Bono #2',
  title: 'Rutina 7 Minutos de Paz',
  utility: 'Convierte tus tarjetas en un encuentro diario con Dios.',
  description: 'Una guía paso a paso para hacer una pausa, leer Su Palabra, reflexionar, orar y volver a tu día con mayor paz.',
  image: 'https://cdn.magicpatterns.com/uploads/2VbPqWf3iuy4rYQrqe3WR9/03_bono_2_rutina_7_minutos.png'
}, {
  label: 'Bono #3',
  title: 'Declaraciones de Fe para Momentos Difíciles',
  utility: 'Palabras para declarar en voz alta cuando tu fe necesita fortalecerse.',
  description: 'Declaraciones breves basadas en la Biblia para llevar Su Palabra a tus pensamientos, tus palabras y tu día.',
  image: 'https://cdn.magicpatterns.com/uploads/gMXJ6bTD2aPYqqE7L18AyC/04_bono_3_declaraciones_fe.png'
}, {
  label: 'Bono #4',
  title: 'Rincón de Paz en Casa',
  utility: 'El lugar de tu casa donde tu Botiquín siempre estará a mano.',
  description: 'Cómo preparar un pequeño espacio para encontrarte con Dios y crear un momento de lectura, reflexión y oración.',
  image: 'https://cdn.magicpatterns.com/uploads/c7MAVvPZjT6HRbVrWtBFFf/05_bono_4_rincon_de_paz.png'
}];
export const socialProof = {
  title: 'Personas que ya confiaron en nuestros materiales 💛',
  image: 'https://cdn.magicpatterns.com/uploads/wauH2spy5vWGejMa3b5Nmo/ChatGPT_Image_24_sept_2026,_06_00_05_p.m..png',
  imageAlt: 'Recomendaciones reales de clientes en la página de Facebook Tu Conexión Educativa: Mariana González, Rocío Baldevenito Torres, Clarisa Sandoval, Naty Muñoz y Liliana Rajo.'
};
export const offerItems: string[] = ['50 Tarjetas Bíblicas', 'Cajita imprimible', 'Mapa de Emergencia Espiritual', 'Rutina 7 Minutos de Paz', 'Declaraciones de Fe para Momentos Difíciles', 'Rincón de Paz en Casa'];
export const afterPurchase = {
  title: '¿Qué pasa después de comprar?',
  steps: [{
    title: 'Realizas tu compra',
    description: 'Completa el pago de forma segura.'
  }, {
    title: 'Recibes tu acceso',
    description: 'Después de la compra recibirás el acceso al material digital.'
  }, {
    title: 'Descargas los archivos',
    description: 'Descarga los PDF desde tu dispositivo.'
  }, {
    title: 'Imprimes y armas tu Botiquín',
    description: 'Imprime, recorta las tarjetas y arma tu propio Botiquín Espiritual en casa.'
  }] as Step[],
  note: 'Botiquín Espiritual es un producto 100% digital. No se envía ningún producto físico.'
};
export const guarantee = {
  title: 'Pruébalo con tranquilidad durante 7 días',
  body: 'Descarga tu Botiquín Espiritual, imprímelo y úsalo en casa. Si sientes que no es para ti, te devolvemos el 100% de tu pago.',
  claim: 'Sin preguntas y sin complicaciones.'
};
export const faqs: Faq[] = [{
  question: '¿Es un producto físico o digital?',
  answer: 'Es 100% digital. Recibes los archivos en PDF para imprimir en tu casa o en una imprenta. No se envía ningún producto físico.'
}, {
  question: '¿Cómo recibo el material?',
  answer: 'Después del pago te llega un correo con el enlace de descarga, por lo general en pocos minutos. Revisa también la carpeta de spam o promociones.'
}, {
  question: '¿Puedo verlo desde el celular?',
  answer: 'Sí. Los archivos están en PDF, así que puedes abrirlos desde tu teléfono, tablet o computadora.'
}, {
  question: '¿Necesito imprimirlo?',
  answer: 'Para armar tu Botiquín con las tarjetas y la cajita, sí: se imprime en casa con cualquier impresora doméstica. Los bonos también puedes leerlos directamente desde tu dispositivo.'
}, {
  question: '¿Qué incluye exactamente?',
  answer: '50 tarjetas bíblicas imprimibles, la cajita “Botiquín Espiritual” imprimible y 4 bonos: Mapa de Emergencia Espiritual, Rutina 7 Minutos de Paz, Declaraciones de Fe para Momentos Difíciles y Rincón de Paz en Casa.'
}, {
  question: '¿Cómo funciona la garantía?',
  answer: 'Tienes 7 días para probarlo. Si sientes que no es para ti, te devolvemos el 100% de tu pago, sin preguntas.'
}, {
  question: '¿Cómo lo imprimo?',
  answer: 'Puedes imprimirlo con cualquier impresora doméstica, en hoja A4 o carta. Te recomendamos papel un poco más grueso para las tarjetas y la cajita. Después solo recortas y armas.'
}, {
  question: '¿Qué tamaño tienen las tarjetas?',
  answer: 'Las tarjetas vienen varias por hoja, en un tamaño práctico para guardar en la cajita, en tu bolso o en tu Biblia.'
}, {
  question: '¿Puedo volver a imprimirlo?',
  answer: 'Sí. El archivo es tuyo, así que puedes volver a imprimir tus tarjetas cada vez que quieras para tu uso personal o para regalar a tu familia.'
}, {
  question: '¿Cómo accedo después de comprar?',
  answer: 'Desde el enlace del correo puedes descargar todo cuando quieras. Te sugerimos guardar los PDF en tu teléfono o computadora para tenerlos siempre disponibles.'
}];